module.exports = __webpack_public_path__ + "assets/img/jury-duty-summons.58bfdefa.png";